/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { DlsgPolicy } from '../models/DlsgPolicy';

export class ListDlsgPoliciesResponse {
  'dlsgPolicies'?: Array<DlsgPolicy>;
  /**
  * Cursor that points to the first record of the next page of results. Pass this value in the next request. 
  */
  'nextToken'?: string;
  /**
  * Total number of backup jobs that matched the filter options.
  */
  'totalCount'?: number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "dlsgPolicies",
      "baseName": "dlsgPolicies",
      "type": "Array<DlsgPolicy>",
      "format": ""
    },
    {
      "name": "nextToken",
      "baseName": "nextToken",
      "type": "string",
      "format": ""
    },
    {
      "name": "totalCount",
      "baseName": "totalCount",
      "type": "number",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListDlsgPoliciesResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

